import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

import TopContainer from "../components/TopContainer"
import Footer from "../components/Footer"
import Blocks from "../components/Blocks"
import { Group, Col, Section, CtaButton } from "../components/common"

class CareersPage extends Component {
  state = {
    rows: [
      { text: "Business Manager" },
      { text: "Data Analysts" },
      { text: "Data Architects" },
      { text: "Economists" },
      { text: "ESG Analysts" },
      { text: "Financial Analysts" },
      { text: "Policy Analysts" },
      { text: "Reporting Analysts" },
      { text: "Research Analysts" },
      { text: "Social Impact Quants" },
      { text: "Case Managers" },
    ],
  }

  renderDivider() {
    return (
      <div style={{ width: "100%", height: 2, backgroundColor: "#919495" }} />
    )
  }

  renderRows() {
    return this.state.rows.map((row, index) => {
      return (
        <div className="careerRow">
          {this.renderDivider()}
          <div
            style={{
              position: "relative",
              paddingTop: 18,
              paddingBottom: 18,
              fontSize: 22,
            }}
          >
            {row.text}
            <div
              style={{
                position: "absolute",
                right: 0,
                top: 0,
              }}
            >
              <CtaButton linkTo={"contact"} dark={true} />
            </div>
          </div>
        </div>
      )
    })
  }

  render() {
    return (
      <>
        <Layout>
          <SEO title="Home" keywords={[]} />
          <Section dark={true} hasDivider={false}>
            <div style={{ height: 100 }} />
            <Group>
              <Col size="whole">
                <div className="headingAccent" />
                <div style={{ height: 32 }} />

                <h3 className="headerBigText">
                  Careers at The S Factor Co. are for people who want to make
                  the world a better place. For people who believe in
                  transparency, accountability and legitimate, unbiased content.
                </h3>
                <p style={{ fontSize: 24, width: "70%", lineHeight: 1.3 }}>
                  We are always looking for top talent who can help us inform
                  decision makers reliant on our information.
                </p>

                <p style={{ fontSize: 24, width: "70%", lineHeight: 1.3 }}>
                  Check back here regularly for updates on current available
                  positions.
                </p>
              </Col>
            </Group>
            <div style={{ height: 80 }} />
          </Section>

          <Section>
            <h3>Current open positions</h3>
            {this.renderRows()}
            {this.renderDivider()}

            <div style={{ height: 32 }} />

            <p style={{ fontSize: 18 }}>
              For consideration, please send cover letter and resume to{" "}
              <a href="mailto:careers@thesfactor.co">careers@thesfactor.co</a>.
            </p>
          </Section>
        </Layout>
      </>
    )
  }
}

export default CareersPage
